import React, { useEffect, useState, useContext } from 'react';
import { Box, Container, Typography, Link, Button } from '@mui/material';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import Grid from '@mui/material/Grid2';
import axiosInstance from '../axiosConfig';
import { jwtDecode } from 'jwt-decode';
import { ProfileContext } from '../context/ProfileContext';

const Footer = () => {
  const { userProfile } = useContext(ProfileContext);
  const isAuthenticated = !!userProfile;

  const handleDocsClick = async () => {
    let docsToken = localStorage.getItem('docsToken');

    // 1) Falls ein docsToken da ist, prüfen, ob er abgelaufen oder ungültig ist
    if (docsToken) {
      try {
        const decoded = jwtDecode(docsToken); 
        // exp ist in Sekunden, Date.now() in ms, darum *1000
        if (decoded.exp * 1000 < Date.now()) {
          docsToken = null;
          localStorage.removeItem('docsToken');
        }
      } catch (error) {
        // Falls jwtDecode scheitert, ist er ebenfalls unbrauchbar
        docsToken = null;
        localStorage.removeItem('docsToken');
      }
    }

    if (!docsToken) {
      try {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) return;

        const response = await axiosInstance.get('/auth/generate-docs-token', {
          headers: { Authorization: `${authToken}` },
        });

        if (response.data.docsToken) {
          docsToken = response.data.docsToken;
          localStorage.setItem('docsToken', docsToken);
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Docs-Tokens:', error);
        return;
      }
    }

    window.open(`https://schullogbuch24.de/docs/?token=${docsToken}`, '_blank');
  };

  return (
    <Box 
      component="footer"
      sx={{ 
        backgroundColor: '#38629F', 
        color: 'white', 
        height: '64px',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        width: '100%',
        position: 'fixed',
        bottom: 0,
        boxShadow: '0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14), 0px -1px 10px 0px rgba(0, 0, 0, 0.12)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="space-between" alignItems="center">
          
          {/* Copyright (jetzt links) */}
          <Grid item>
            <Typography variant="body2">
              © {new Date().getFullYear()} Schullogbuch24
            </Typography>
          </Grid>

          {/* App-Dokumentation Button (Nur für eingeloggte Nutzer) */}
          {isAuthenticated && (
            <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
              <Button
                onClick={handleDocsClick}
                variant="contained"
                color="primary"
                startIcon={<BookOutlinedIcon />}
                sx={{
                  backgroundColor: 'primary.light',
                  '&:hover': { backgroundColor: 'primary.dark' },
                  color: 'white',
                  fontWeight: 'bold',
                  textTransform: 'none'
                }}
              >
                App-Dokumentation
              </Button>
            </Grid>
          )}

          {/* Links zu Rechtlichem (jetzt rechts) */}
          <Grid item>
            <Typography variant="body2">
            <Link href="https://schullogbuch24.de/impressum/" color="inherit" underline="hover" target="_blank" rel="noopener noreferrer">
              Impressum
            </Link>{' | '}
            <Link href="https://schullogbuch24.de/datenschutz/" color="inherit" underline="hover" target="_blank" rel="noopener noreferrer">
              Datenschutz
            </Link>{' | '}
            <Link href="https://schullogbuch24.de/agb/" color="inherit" underline="hover" target="_blank" rel="noopener noreferrer">
              AGBs
            </Link>
            </Typography>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
